import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlModule } from 'angular-owl-carousel';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { SharedModule } from '../../shared/shared.module';
import { IndexComponent } from './index/index.component';
import { BlogCollectionComponent } from './blog-collection/blog-collection.component';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
	declarations: [
		IndexComponent,
		BlogCollectionComponent
	],

	imports: [
		CommonModule,
		RouterModule,
		NgbModule,
		OwlModule,
		SharedModule,
		LazyLoadImageModule,
		ReactiveFormsModule
	]
})

export class HomeModule { }
